import { FC, useState } from 'react';
import { AiOutlineClose, AiOutlineSearch } from 'react-icons/ai';
import { twMerge } from 'tailwind-merge';
import strings from '../shared/shared.translations';
import { TextInput } from '../form/TextInput';

interface SearchProps {
  onChange: (newValue: string) => void;
  className?: string;
  inputClassName?: string;
}

export const Search: FC<SearchProps> = ({ onChange, className, inputClassName }) => {
  const [value, setValue] = useState<string>('');

  const clear = () => {
    setValue('');
    onChange('');
  };

  const wrapperClassName = twMerge('relative flex items-center', className);
  const fieldClassName = twMerge('flex pl-[40px] pr-[20px] rounded-md', inputClassName);

  return (
    <div className={wrapperClassName}>
      <AiOutlineSearch className="absolute left-0 ml-[10px] text-[24px]" />
      <TextInput
        name="search"
        value={value}
        onChange={newValue => {
          setValue(newValue);
          onChange(newValue);
        }}
        className={fieldClassName}
        placeholder={strings.common.search}
      />
      {value !== '' && <AiOutlineClose className="absolute right-0 mr-[10px] text-[24px]" onClick={clear} />}
    </div>
  );
};
